module.exports = __webpack_public_path__ + "media/assets/images/edit-icon-3054711ff302b0a604f288fcce308bd7.svg";